<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_2">Argument</a></h2><a id="page_2">
<p class="noindent">To Laius, King of Thebes, an oracle foretold that the child born to him by his queen Jocasta would slay his father and wed his mother. So when in time a son was born the infant’s feet were riveted together and he was left to die on Mount Cithaeron. But a shepherd found the babe and tended him, and delivered him to another shepherd who took him to his master, the King of Corinth. Polybus being childless adopted the boy, who grew up believing that he was indeed the King’s son. Afterwards doubting his parentage he inquired of the Delphic god and heard himself the word declared before to Laius. Wherefore he fled from what he deemed his father’s house and in his flight he encountered and unwillingly slew his father Laius. Arriving at Thebes he answered the riddle of the Sphinx and the grateful Thebans made their deliverer king. So he reigned in the room of Laius, and espoused the widowed queen. Children were born to them and Thebes prospered under his rule, but again a grievous plague fell upon the city. Again the oracle was consulted and it bade them purge themselves of blood-guiltiness. Oedipus denounces the crime of which he is unaware, and undertakes to track out the criminal. Step by step it is brought home to him that he is the man. The closing scene reveals Jocasta slain by her own hand and Oedipus blinded by his own act and praying for death or exile.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Argument.vue?a3479776